import { render } from "./DecadeButtonComponent.vue?vue&type=template&id=e48c83b0"
import script from "./DecadeButtonComponent.vue?vue&type=script&lang=js"
export * from "./DecadeButtonComponent.vue?vue&type=script&lang=js"

import "./DecadeButtonComponent.vue?vue&type=style&index=0&id=e48c83b0&lang=css"

import exportComponent from "/root/workspace/web--ming-pan_4MVO/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__